import { fullEscapeHTML } from './htmlUtil.js';
const CODE_SENTINEL_PREFIX = '___APCK_CODE_';
const CODE_SENTINEL_SUFFIX = '___';
const ESC_SENTINEL_PREFIX = '___APCK_ESC_';
const ESC_SENTINEL_SUFFIX = '___';
const ESCAPABLE_CHARS_RE = /\\([\[\]\*])/g;
// Code sections
export function extractCodeSections(markup) {
    const codeBlocks = [];
    const processed = markup.replace(/\[\[code:([\s\S]*?)\]\](?!\])/g, (_match, body) => {
        const index = codeBlocks.length;
        codeBlocks.push(body);
        return `${CODE_SENTINEL_PREFIX}${index}${CODE_SENTINEL_SUFFIX}`;
    });
    return { processed, codeBlocks };
}
function normalizeCodeBody(raw) {
    return raw.replace(/\\([\[\]\$])/g, '$1');
}
export function restoreCodeSections(html, codeBlocks) {
    const re = new RegExp(CODE_SENTINEL_PREFIX + '(\\d+)' + CODE_SENTINEL_SUFFIX, 'g');
    return html.replace(re, (_match, idxStr) => {
        const idx = parseInt(idxStr, 10);
        const raw = codeBlocks[idx] || '';
        return `<code>${fullEscapeHTML(normalizeCodeBody(raw))}</code>`;
    });
}
// Escaped characters
export function extractEscapes(input) {
    const escapes = [];
    const processed = input.replace(ESCAPABLE_CHARS_RE, (_match, ch) => {
        const idx = escapes.length;
        escapes.push(ch);
        return `${ESC_SENTINEL_PREFIX}${idx}${ESC_SENTINEL_SUFFIX}`;
    });
    return { processed, escapes };
}
export function restoreEscapes(text, escapes) {
    const re = new RegExp(ESC_SENTINEL_PREFIX + '(\\d+)' + ESC_SENTINEL_SUFFIX, 'g');
    return text.replace(re, (_match, idxStr) => {
        const idx = parseInt(idxStr, 10);
        return escapes[idx] ?? '';
    });
}
// Markup header
export function stripMarkupHeader(input) {
    return input.replace(/^\s*\[\[markup\]\]\s*/, '');
}
